module.exports = __webpack_public_path__ + "img/icon_map_32_on_001.08cb3f5d.png";